import { LocalStorageKeys } from '../../_models/localStorageKeys';
import { Carrinho } from '../mercado-partsfy/list/_models/Carrinho';
import { User } from 'app/_models/user';

declare const cc: boolean;
declare const CryptoJS: any;
declare const isEmpty: any;
declare const getJavascriptDateFromIsoDate: any;

export class LocalStorageUtilsBuyer {
    private localStorageKeys: LocalStorageKeys

    constructor() {
        this.localStorageKeys = new LocalStorageKeys();
    }

    public checkIfIsActive(dados: CentralSemaforoCotacaoLocalStorage): boolean {
        if (isEmpty(dados.ultima_atualizacao))
            return false;

        let agora = new Date().getTime();
        let ultima_atualizacao = getJavascriptDateFromIsoDate(dados.ultima_atualizacao).getTime();
        let FIVE_MIN = 5 * 60 * 1000;

        return (agora - ultima_atualizacao) <= FIVE_MIN;
    }

    public limparDadosLocaisDadosCentralSemaforo() {
        localStorage.removeItem(this.localStorageKeys.csem);
    }

    private obterLocalStorageDadosCentralSemaforo(): CentralSemaforoCotacaoLocalStorage[] {
        try {
            let lsCSem = localStorage.getItem(this.localStorageKeys.csem);

            if (isEmpty(lsCSem))
                return [];

            if (!cc)
                return JSON.parse(lsCSem)

            let decrypted = CryptoJS.AES.decrypt(lsCSem, this.localStorageKeys.cryptKey);
            let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

            return result;
        } catch (e) {
            this.limparDadosLocaisDadosCentralSemaforo();
        }
    }

    public deleteLocalStorageShoppingCartData(user: User) {
        let loggedUserId = user.id;
        localStorage.removeItem(this.localStorageKeys.getScar(loggedUserId));
    }

    public deleteShouldOpenAvaliacoesModalData(usuarioCentralId: number) {
        localStorage.removeItem(this.localStorageKeys.getCavaliacao(usuarioCentralId));
    }

    private getAllLocalStorageShoppingCartData(user: User) {
        try {
            let loggedUserId = user.id;

            let lsSCar = localStorage.getItem(this.localStorageKeys.getScar(loggedUserId));

            if (isEmpty(lsSCar))
                return [];

            if (!cc)
                return JSON.parse(lsSCar)

            let decrypted = CryptoJS.AES.decrypt(lsSCar, this.localStorageKeys.cryptKey);
            let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

            return result;
        } catch (e) { }
    }

    private getAllShouldOpenAvaliacoesModalData(user: User): rememberInTwoHoursAvaliacaoLocalStorage[] {
        try {
            let loggedUserId = user.id;
            let lsCAvaliacao = localStorage.getItem(this.localStorageKeys.getCavaliacao(loggedUserId));

            if (isEmpty(lsCAvaliacao))
                return [];

            if (!cc)
                return JSON.parse(lsCAvaliacao)

            let decrypted = CryptoJS.AES.decrypt(lsCAvaliacao, this.localStorageKeys.cryptKey);
            let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

            return result;
        } catch (e) { }
    }

    private getLocalStorageShoppingCartData(user: User): any {
        try {
            let shoppingCartArray = this.getAllLocalStorageShoppingCartData(user)

            if (isEmpty(shoppingCartArray))
                return [];

            return this.getShoppingCart(user, shoppingCartArray);
        } catch (e) { }
    }

    public getShoppingCart(user: User, shoppingCartArray: any) {
        let userId = user.id;
        let selectedUserId = user?.selectedUser?.id ?? user.id;
        let shoppingCartItem = shoppingCartArray.filter(item => item.userId == selectedUserId);

        if(new Date(shoppingCartItem.expirationDate) < new Date) {
            this.removeShoppingCartItemData(user)
            return
        }

        return shoppingCartItem[0]
    }

    public getShoppingCartData(user: User): MercadoPartsfyCotacaoLocalStorage {
        let dados = this.getLocalStorageShoppingCartData(user);

        if (isEmpty(dados))
            return null;

        return dados;
    }

    public getShouldOpenAvaliacoesModal(user: User): boolean {
        let userId = user?.selectedUser?.id ?? user.id;
        let rememberInTwoHoursArray = this.getAllShouldOpenAvaliacoesModalData(user);
        let rememberInTwoHoursUser = rememberInTwoHoursArray.filter(item => item.userId == userId)[0];

        if (isEmpty(rememberInTwoHoursUser))
            return true;

        if (new Date(rememberInTwoHoursUser.expirationDate) < new Date()) {
            this.removeShouldOpenAvaliacoesModalData(user);
            return true;
        }

        return false;
    }

    public obterDadosCentralSemaforo(is_conversor: boolean): CentralSemaforoCotacaoLocalStorage {
        let dados = this.obterLocalStorageDadosCentralSemaforo();

        if (isEmpty(dados))
            return null;

        return dados.find(d => d.is_conversor === is_conversor);
    }

    public saveShoppingCartData(user: User, shoppingCart: Carrinho) {
        let userId = user.id;
        let selectedUserId = user?.selectedUser?.id ?? user.id;
        let cart = this.getAllLocalStorageShoppingCartData(user)
        let expirationDate = new Date()
        expirationDate.setDate(expirationDate.getDate() + 7)

        let userCart = { shoppingCart, expirationDate, userId: selectedUserId }

        let index = cart.findIndex((obj => obj.userId == selectedUserId));

        if(index >= 0)
            cart[index] = userCart;
        else
            cart.push(userCart)

        let scar = JSON.stringify(cart);
        let encrypted = CryptoJS.AES.encrypt(scar, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.getScar(userId), scar);
        else
            localStorage.setItem(this.localStorageKeys.getScar(userId), encrypted.toString());
    }

    public saveShouldOpenAvaliacoesModalData(user: User): void {
        let loggedUserId = user.id;
        let userId = user?.selectedUser?.id ?? user.id;
        let rememberInTwoHoursArray = this.getAllShouldOpenAvaliacoesModalData(user)

        let expirationDate = new Date()
        expirationDate.setHours(expirationDate.getHours() + 2)

        let rememberInTwoHoursUser: rememberInTwoHoursAvaliacaoLocalStorage = { expirationDate, userId: userId }

        let index = rememberInTwoHoursArray.findIndex((obj => obj.userId == userId));

        if(index >= 0)
            rememberInTwoHoursArray[index] = rememberInTwoHoursUser;
        else
            rememberInTwoHoursArray.push(rememberInTwoHoursUser)

        let cavaliacao = JSON.stringify(rememberInTwoHoursArray);
        let encrypted = CryptoJS.AES.encrypt(cavaliacao, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.getCavaliacao(loggedUserId), cavaliacao);
        else
            localStorage.setItem(this.localStorageKeys.getCavaliacao(loggedUserId), encrypted.toString());
    }

    public removeShoppingCartItemData(user: User) {
        let userId = user.id;
        let selectedUserId = user?.selectedUser?.id ?? user.id;
        let cart = this.getAllLocalStorageShoppingCartData(user)

        cart = cart.filter(item => item.userId !== selectedUserId);

        if(cart.length == 0) {
            this.deleteLocalStorageShoppingCartData(user)
            return
        }

        let scar = JSON.stringify(cart);
        let encrypted = CryptoJS.AES.encrypt(scar, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.getScar(userId), scar);
        else
            localStorage.setItem(this.localStorageKeys.getScar(userId), encrypted.toString());
    }

    private removeShouldOpenAvaliacoesModalData(user: User) {
        let userId = user.id;
        let selectedUserId = user?.selectedUser?.id ?? user.id;
        let rememberInTwoHoursArray = this.getAllLocalStorageShoppingCartData(user)

        rememberInTwoHoursArray = rememberInTwoHoursArray.filter(item => item.userId !== selectedUserId);

        if(rememberInTwoHoursArray.length == 0) {
            this.deleteShouldOpenAvaliacoesModalData(userId)
            return
        }

        let cavaliacao = JSON.stringify(rememberInTwoHoursArray);
        let encrypted = CryptoJS.AES.encrypt(cavaliacao, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.getCavaliacao(userId), cavaliacao);
        else
            localStorage.setItem(this.localStorageKeys.getCavaliacao(userId), encrypted.toString());
    }

    public salvarDadosCentralSemaforo(filtro: CentralSemaforoCotacaoFiltroLocalStorage, is_conversor: boolean) {
        let todosDados = this.obterLocalStorageDadosCentralSemaforo();

        if (isEmpty(todosDados))
            todosDados = [];

        let indiceDados = todosDados.findIndex(d => d.is_conversor === is_conversor);

        if (indiceDados > -1)
            todosDados.splice(indiceDados, 1);

        todosDados.push({ filtro, is_conversor, ultima_atualizacao: new Date() });

        let csem = JSON.stringify(todosDados);
        let encrypted = CryptoJS.AES.encrypt(csem, this.localStorageKeys.cryptKey);

        if (!cc)
            localStorage.setItem(this.localStorageKeys.csem, csem);
        else
            localStorage.setItem(this.localStorageKeys.csem, encrypted.toString());
    }
}

export interface CentralSemaforoCotacaoLocalStorage {
    filtro: CentralSemaforoCotacaoFiltroLocalStorage;
    is_conversor: boolean;
    ultima_atualizacao: Date;
}

export interface CentralSemaforoCotacaoFiltroLocalStorage {
    fase: string;
    inconsistencias: boolean;
    link_externo: boolean;
    aguardando_nota: boolean;
    texto: string;
}

export interface MercadoPartsfyCotacaoLocalStorage {
    shoppingCart: Carrinho;
    ultima_atualizacao: Date;
}

interface rememberInTwoHoursAvaliacaoLocalStorage {
    expirationDate: Date;
    userId: number;
}
